import React from "react";
import { IonContent, IonPage } from '@ionic/react';
import { Redirect, RouteComponentProps, withRouter } from "react-router-dom";
import axiosInstance from '../services/AxiosInstance';
import styles from './css/Portal.module.css';

interface PortalProps extends RouteComponentProps {
    // Define the props here
}
interface PortalState {
    // Define the state here
}

class Portal extends React.Component<PortalProps, PortalState> {
    constructor(props: PortalProps) {
        super(props);       

        this.state = {}
    }

    componentDidMount() {
        this.getAmountChallengesDone()        
    }

    async getAmountChallengesDone() {
        var id = localStorage.getItem("id");
        var token = localStorage.getItem("token");

        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        let done: number = 0

        axiosInstance.get("/Results/Employee/" + id, config).then((res) => {
            res.data.forEach((quiz: any) => {
                if (quiz.score >= 0) {
                    done++
                }
            })
            this.getLevel(done);
        })
    }

    async getLevel(challengesDone: number) {
        let level: number = 1
        let challengesForNextLevel: number[] = [3, 4, 3, 2]
        let challengesToDo = challengesForNextLevel[0]
        let index: number = 0

        while (challengesDone >= challengesToDo) {
            challengesDone -= challengesToDo;
            level++;
            if (index % 2 == 0) {
                challengesForNextLevel.push(3)
            } else {
                challengesForNextLevel.push(2)
            }
            index++
            challengesToDo = challengesForNextLevel[index]
        }

        let challengesLeftForNextLevel = challengesToDo -= challengesDone

        //console.log(level)
        localStorage.setItem("level", "" + level)
        localStorage.setItem("challengesLeft", "" + challengesLeftForNextLevel)
    }

    goToCases() {
        const { history } = this.props;
        history.push("/Cases");
    }
    goToProfile() {
        const { history } = this.props;
        history.push("/Profile");
    }

    render() {
        // refresh page to load correct data
        const reloadCount = localStorage.getItem('reloadCount');
        if (reloadCount != null) {
            if (parseInt(reloadCount) < 2) {
                localStorage.setItem('reloadCount', String(reloadCount + 1));
                window.location.reload();
            } else {
                localStorage.removeItem('reloadCount');
            }
        }

        const value = localStorage.getItem('WelcomeSeen' + localStorage.getItem("id"));
        if (!value) {
            return <Redirect to="/WelcomeScreen" />;
          }
        
        return (
            <IonPage ion-no-header="true">
                <IonContent fullscreen ion-no-border="true">
                    <div
                        // Background Linear Gradient
                        className={styles.background}
                    >
                        <div className={styles.layoutPortal}>
                            <div
                                className={styles.bigbuttonCases}
                                onClick={() => this.goToCases()}
                            >
                                <div className={styles.textFont}>
                                    <div className={styles.textPortal}>Mijn Onderwerpen</div>
                                </div>
                                <img
                                    className={styles.iconsPortal}
                                    src={require("../assets/icons/cases.png")}
                                />
                            </div>
                        </div>

                        <div className={styles.profilePanel}>
                            <div
                                className={styles.bigbutton}
                                onClick={() => this.goToProfile()}
                            >
                                <div className={styles.textFont}>
                                    <div className={styles.textPortal}>Mijn profiel</div>
                                </div>
                                <img
                                    className={styles.iconsPortal}
                                    src={require("../assets/icons/profile.png")}
                                />
                            </div>
                        </div>
                    </div>
                </IonContent>
            </IonPage>
        );
    }
}

export default withRouter(Portal)
